// Get: everyone
// Write: root

import { CalilConnection } from "./Calil";
export class School {
  constructor(
    public id: string | undefined = undefined,
    public schoolName: string = "",
    public city: string = "",
    public numCards: number = 0,
    public schoolType: SchoolType = "elementary", // if not exist on document, it is "elementary"
    public calilConnection: CalilConnection = { enable: false }
  ) {}
}

/**
 * 今日から3ヶ月後の日付を YYYY-MM-DD で返す（月末を超える場合はその月の末日）
 */
export function defaultTrialEndDate(today: Date = new Date()): string {
  const year = today.getFullYear();
  const month = today.getMonth() + 3;
  const lastDay = new Date(year, month + 1, 0).getDate();
  const date = new Date(year, month, Math.min(today.getDate(), lastDay));
  const pad = (n: number) => `${n}`.padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export class SchoolCreateRequest extends School {
  constructor(
    readonly id: string | undefined = undefined,
    readonly schoolName: string = "",
    readonly city: string = "",
    readonly prefix: string = "",
    readonly schoolType: SchoolType = "elementary",
    readonly emailRegex: string = "",
    readonly maxStudentNum: number = 9999,
    readonly adminEmail: string = "", // adminアカウント情報の送付先
    readonly isTrial: boolean = true,
    readonly trialEndDate: string = defaultTrialEndDate() // YYYY-MM-DD
  ) {
    super(id, schoolName, city, 0, schoolType);
    this.numCards = 0;
  }
}

export type SchoolType = "elementary" | "juniorhigh";
